import { scrollToId } from "./Header";
import { useLang } from "./i18n";

export function Footer() {
  const { t, images } = useLang();
  return (
    <footer className="t-bg-deep t-border relative overflow-hidden border-t">
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-20 sm:px-8">
        <div className="t-watermark pointer-events-none select-none text-center font-display text-[18vw] font-semibold leading-[0.85] tracking-tight lg:text-[11rem]">
          Settld.
        </div>

        <div className="-mt-6 grid gap-12 md:grid-cols-[1.4fr_1fr_1fr_1fr] lg:-mt-10">
          <div>
            <div className="flex items-center gap-2.5">
              <img
                src={images.logoMark}
                alt="Settld logo"
                className="h-10 w-10 rounded-xl shadow-[0_4px_16px_rgba(0,0,0,0.15)]"
              />
              <span className="t-text font-sans text-[22px] font-extrabold tracking-tight">
                Settld<span className="text-aqua-500">.</span>
              </span>
            </div>
            <p className="t-text-muted mt-4 max-w-xs text-sm leading-relaxed">{t.footer.tagline}</p>
          </div>
          {t.footer.columns.map((col, i) => (
            <div key={i}>
              <div className="t-faint text-[11px] font-bold uppercase tracking-[0.22em]">{col.title}</div>
              <ul className="mt-5 space-y-3">
                {col.links.map((link, j) => (
                  <li key={j}>
                    <a
                      href="#top"
                      data-testid={`footer-link-${i}-${j}`}
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToId("#top");
                      }}
                      className="t-text-muted text-sm transition-colors duration-200 hover:text-maple"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="t-border t-text-muted mt-16 flex flex-col items-center justify-between gap-3 border-t pt-8 text-xs md:flex-row">
          <span>{t.footer.rights}</span>
          <span>{t.footer.authorized}</span>
        </div>
      </div>
    </footer>
  );
}
